import React, { useMemo } from 'react';
import { IBooking } from '../../../utils/entities/interface';
import { capitalizeWords } from '../../../utils/helper';

export const getUniqueServiceTypes = (booking: IBooking): string[] => {
  if (!booking.services?.length) return [];

  const seen = new Set<string>();
  const unique: string[] = [];

  booking.services.forEach((service) => {
    const label = capitalizeWords(service.serviceType || '').trim();
    if (!label) return;

    const key = label.toLowerCase();
    if (seen.has(key)) return;

    seen.add(key);
    unique.push(label);
  });

  return unique;
};

export const ServiceTypesCell = ({ booking }: { booking: IBooking }) => {
  const serviceTypes = useMemo(
    () => getUniqueServiceTypes(booking),
    [booking.services],
  );

  if (!serviceTypes.length) {
    return <>N/A</>;
  }

  return <>{serviceTypes.join(', ')}</>;
};
